import { createSlice } from '@reduxjs/toolkit';
import { authedMemberReducer } from './reducers/authed-member.reducer';
import { loginMemberReducer } from './reducers/login-member.reducer';
import { loadingMemberReducer } from './reducers/loading-member.reducer';
import { memberErrorReducer } from './reducers/member-error.reducer';
import { logoutMemberReducer } from './reducers/logout-member.reducer';
import { initialMemberState } from './state';

export const memberSlice = createSlice({
  name: 'Member',
  initialState: initialMemberState,
  reducers: {
    authed: authedMemberReducer,
    login: loginMemberReducer,
    logout: logoutMemberReducer,
    loading: loadingMemberReducer,
    error: memberErrorReducer,
  },
});

export const memberSliceReducer = memberSlice.reducer;
